webpackJsonp([78],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_FilterList__);




var changeState = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
		var id = _ref2.id;
		var modelRow;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						modelRow = this.rows.filter(function (row) {
							return row.id === id;
						})[0];
						_context.next = 3;
						return this.$http.patch('//products.japisale.com' + '/warehouses/' + id + '/flag-active', { flagActive: modelRow.flagActive });

					case 3:
						this.loadData();

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changeState(_x) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function columnSortableEvent(_ref3) {
	var id = _ref3.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_6__components_shared_FilterList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: function data() {
		return {
			columns: [{ id: 1, name: 'N', code: 'number', isSortable: { down: true, up: false } }, { id: 2, name: 'Name', code: 'name', isSortable: { down: true, up: false } }, { id: 3, name: 'R.U.C.', code: 'ruc', isSortable: { down: true, up: false } }, { id: 4, name: 'Direction', code: 'direction', isSortable: { down: true, up: false } }, { id: 5, name: 'Total Amount', code: 'amount', isSortable: { down: true, up: false } }, { id: 6, name: '', code: '' }],
			filterValue: 1,
			flagActive: null,
			limit: 10,
			loading: false,
			page: 1,
			resource: null,
			rows: [{
				number: 1,
				name: 'Ariel Esteban Puga Ogalde',
				ruc: 20214392548,
				direction: 'av.Arequipa 3492 Lima-Perú',
				amount: 530.39
			}, {
				number: 1,
				name: 'Ariel Esteban Puga Ogalde',
				ruc: 20214392548,
				direction: 'av.Arequipa 3492 Lima-Perú',
				amount: 530.39
			}, {
				number: 1,
				name: 'Ariel Esteban Puga Ogalde',
				ruc: 20214392548,
				direction: 'av.Arequipa 3492 Lima-Perú',
				amount: 530.39
			}, {
				number: 1,
				name: 'Ariel Esteban Puga Ogalde',
				ruc: 20214392548,
				direction: 'av.Arequipa 3492 Lima-Perú',
				amount: 530.39
			}, {
				number: 1,
				name: 'Ariel Esteban Puga Ogalde',
				ruc: 20214392548,
				direction: 'av.Arequipa 3492 Lima-Perú',
				amount: 530.39
			}],
			totalPages: 5,
			search: null,
			sortDirection: null,
			sortField: null
		};
	},

	name: 'minibar',
	methods: {
		changeState: changeState,
		columnSortableEvent: columnSortableEvent,
		searchByColumn: searchByColumn,
		selectedFilter: selectedFilter
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".column-transfer[data-v-6488bad3]{position:absolute;right:158px}.column-transfer a i[data-v-6488bad3]{color:#2e394b;height:16px!important;margin-top:13px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/billing/List.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,WAAa,CACd,AACD,sCACI,cAAe,AACf,sBAAwB,AACxB,eAAiB,CACpB","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.column-transfer[data-v-6488bad3] {\n  position: absolute;\n  right: 158px;\n}\n.column-transfer a i[data-v-6488bad3] {\n    color: #2e394b;\n    height: 16px !important;\n    margin-top: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1409);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("40d2bd38", content, true);

/***/ }),

/***/ 1652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billing"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue,
      "loading": _vm.loading
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Billing"
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": false,
      "include-settings": true,
      "include-delete-single": true,
      "selectable": false,
      "switch-value": 'flagActive'
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.ruc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.direction))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.code_roomtype)), (props.row.code_roomtype && props.row.room_number) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(props.row.room_number))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1494)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1245),
  /* template */
  __webpack_require__(1652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6488bad3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/78.c52fcccbfc50a9907296.js